import React, { useEffect, useMemo, useState } from 'react'
import Heading from '../components/Heading'
import OrderList from '../compositions/Order/OrderList'
import { useFetchData } from '../hooks/useFetchData'
import { Order } from '../types/Order'
import CustomizationDetail from '../compositions/Order/CustomizationDetail'
import { useTranslation } from 'react-i18next'
import { useFetchSingle } from '../hooks/useFetchSingle'
import { ButtonSetting } from '../types/ButtonSetting'
import Pagination from '../components/Pagination'
import { ApiRoutes } from '../services/ApiService'

const Orders = () => {
    const [customization, setCustomization] = useState<[number, string] | null>(
        null
    )
    const [detailList, setDetailList] = useState<number[]>([])
    const [currentPage, setCurrentPage] = useState<number>(1)
    const itemsPerPage = useMemo(() => 10, [])

    const showCustomization = (customization: [number, string] | null) => {
        setCustomization(customization)
    }

    const { t } = useTranslation(['orders'])

    const {
        data: orders,
        fetch,
        isLoading,
        pagination,
    } = useFetchData<Order>(ApiRoutes.ORDERS)

    const { data: buttonSetting, fetch: fetchButton } =
        useFetchSingle<ButtonSetting>(ApiRoutes.BUTTON_SETTINGS)

    useEffect(() => {
        fetch({
            page: currentPage.toString(),
            perPage: itemsPerPage.toString(),
        })
    }, [fetch, currentPage, itemsPerPage])

    useEffect(() => {
        fetchButton()
    }, [fetchButton])

    const changeDetailList = (order_id: number) => {
        setDetailList((prev) => {
            if (prev.includes(order_id))
                return prev.filter((n) => n !== order_id)
            else return [...prev, order_id]
        })
    }

    return (
        <div>
            <Heading level={2} classes={'zr-mt-4'}>
                {t('title')}
            </Heading>
            {!customization ? (
                <div>
                    <OrderList
                        showCustomization={showCustomization}
                        detailList={detailList}
                        changeDetailList={changeDetailList}
                        orders={orders}
                        isLoading={isLoading}
                    />
                    {pagination && pagination.lastPage > 1 && (
                        <Pagination
                            totalPages={pagination.lastPage}
                            currentPage={currentPage}
                            onPageChange={(p: number) => setCurrentPage(p)}
                        />
                    )}
                </div>
            ) : (
                <CustomizationDetail
                    showCustomization={showCustomization}
                    customization={customization}
                    buttonSetting={buttonSetting}
                />
            )}
        </div>
    )
}

export default Orders
